export enum FrameTypesEnum {
      alloy = "alloy",
      premiere = 'premiere'
}